import React, { useContext } from "react";
import classes from "./ScreenHeightWidthTester.module.css";

import { useState, useEffect } from "react";

import { LanguageContext } from "../../App";

function ScreenHeightWidthTester(props) {
  // current scenario selected:

  // window dimensions:
  const { height, width } = useWindowDimensions();

  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );

    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
  }

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const currentLanguage = useContext(LanguageContext);

  return (
    <div className={classes.box}>
      <div className={classes.text}>
        h:{height}px w:{width}px
      </div>
      <div className={classes.text}>{currentLanguage}</div>
    </div>
  );
}

export default ScreenHeightWidthTester;
